import { Menu } from 'bloomer';
import React from 'react';
import styled from 'styled-components';
import i18next from 'i18next';
import { colors } from '../../styles/colors';
import { PreneticsLogo } from '../PreneticsLogo/PreneticsLogo';
import { NavLink } from 'react-router-dom';
import logoutIcon from './log-out-icon.svg';
import { MenuGroup } from './MenuGroup/MenuGroup';
import { menuItems } from './menuItems';

const FullHeightContainer = styled.div`
  background: ${colors.purple};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 14rem;
`;

const FlexGrowMenu = styled(Menu)`
  flex: 1 0 auto;
`;

const SmallerLogo = styled(PreneticsLogo)`
  width: 7rem;
  display: block;
  margin: 1.75rem 0 4rem 1rem;
`;

const Link = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 3.2em;

  div:first-child {
    margin-right: 1.5em;
  }
`;
const Icon = styled.img`
  margin-left: 1rem;
  width: 1.5em;
`;

const Text = styled.div`
  color: white;
  font-size: 0.95em;
  padding-left: 0.5rem;
  &:hover {
    color: white;
  }
`;

export default class LeftMenu extends React.PureComponent {
  render() {
    return (
      <FullHeightContainer>
        <SmallerLogo monochrome={true} />
        <FlexGrowMenu>
          {
            menuItems.map(section => <MenuGroup {...section} key={section.title} />)
          }
        </FlexGrowMenu>
        <NavLink to="/logout" exact>
          <Link>
            <Icon src={logoutIcon} />
            <Text>
              {i18next.t('navBar.logOut')}
            </Text>
          </Link>
        </NavLink>
        <Text>
          <div style={{ margin: '.7em 0 0 .5em' }}>
            <b>{i18next.t('footer.email')}</b>
          </div>
          <div style={{ margin: '.3em 1em 3em .5em', lineHeight: 'initial' }}>
            {`${i18next.t('footer.description')} ${i18next.t('footer.emailAddress')}`}
          </div>
        </Text>
      </FullHeightContainer>
    );
  }
}
